// extracted by mini-css-extract-plugin
module.exports = {"quantity":"ShoppingCartIcon_quantity__30_Rr","icon":"ShoppingCartIcon_icon__BuFHK"};